<div class="container mt-4">
  <div class="row gy-2 align-items-center">
    <div class="col-lg-4 position-relative">
      <spe-step-header
        [number]="1"
        [title]="'Envio do arquivo'"
        [active]="currentStep === StepsImport.stepUpload"
        [checked]="checkedStepUpload"
        [blocked]="true"
        (eventClickChangeStep)="changeStep(StepsImport.stepUpload)"
      >
      </spe-step-header>
    </div>

    <div class="col-lg-4 position-relative">
      <spe-step-header
        [number]="2"
        [title]="'Processamento e verificação'"
        [active]="currentStep === StepsImport.stepProcessing"
        [checked]="checkedStepProcessing"
        [blocked]="true"
        (eventClickChangeStep)="changeStep(StepsImport.stepProcessing)"
      >
      </spe-step-header>
    </div>

    <div class="col-lg-4 position-relative">
      <spe-step-header
        [number]="3"
        [title]="'Revisão e confirmação'"
        [checked]="false"
        [active]="currentStep === StepsImport.stepResult"
        [blocked]="true"
        (eventClickChangeStep)="changeStep(StepsImport.stepResult)"
      >
      </spe-step-header>
    </div>
  </div>

  <div class="mt-4">
    <spe-step-content *ngIf="currentStep === StepsImport.stepUpload">
      <spe-csv-step-upload
        [filesDataForm]="filesDataForm"
        [firstLoading]="firstLoading"
        (eventFileChange)="onChangeFile($event)"
        (eventSubmit)="openImportDialog()"
      >
      </spe-csv-step-upload>
    </spe-step-content>

    <spe-step-content *ngIf="currentStep === StepsImport.stepProcessing">
      <spe-csv-step-processing
        [idImportacao]="idImportacao"
        [statusImport]="statusImport"
        [columnsNotIdentified]="columnsNotIdentified"
        [columnsNotInFile]="columnsNotInFile"
        [requiredColumns]="requiredColumns"
        [alertTitle]="alertTitle"
        [alertMessage]="alertMessage"
        [alertError]="alertError"
        [alertStatus]="alertStatus"
        [showProcessing]="showProcessing"
        [isChecking]="isChecking"
        [checked]="checked"
        [showStepCounters]="showStepCounters"
        [showStepError]="showStepError"
        [showStepFail]="showStepFail"
        [showStepAlert]="showStepAlert"
        [employees]="employees"
        [benefits]="benefits"
        [errors]="errors"
        [errorsToShow]="errorsToShow"
        [columnMappings]="columnMappings"
        (resolvedCountChange)="resolvedColumnCount = $event"
        (requiredConfirmedCountChange)="requiredConfirmedCount = $event"
        (eventShowStepFail)="showStepFail = $event"
        (eventShowStepError)="showStepError = $event"
        (eventErrorsToShow)="errorsToShow = $event"
        (eventQuantidadeLinhasComErro)="quantidadeLinhasComErro = $event"
        (eventEditedLines)="editedLines = $event"
        (eventShowStepResult)="changeStep(StepsImport.stepResult)"
        (eventNewImport)="novaImportacao()"
      >
      </spe-csv-step-processing>
    </spe-step-content>

    <spe-step-content *ngIf="currentStep === StepsImport.stepResult">
      <spe-csv-step-result
        [alertTitle]="alertTitle"
        [alertMessage]="alertMessage"
        [detalhamento]="detalhamento"
        (eventImportResume)="importResume()"
        (eventNewImport)="novaImportacao()"
        (eventDetalhamento)="navigateToDetalhamento()"
      >
      </spe-csv-step-result>
    </spe-step-content>
  </div>
</div>
<spe-import-footer
  *ngIf="currentStep === StepsImport.stepProcessing && showStepFail"
  [count]="columnsNotIdentified.length - resolvedColumnCount"
  [label]="'Colunas para correção'"
  [disabled]="resolvedColumnCount < columnsNotIdentified.length || requiredConfirmedCount < requiredColumns.length"
  [showWarning]="resolvedColumnCount === columnsNotIdentified.length && requiredConfirmedCount < requiredColumns.length"
  (eventContinue)="continueFromFail()"
>
</spe-import-footer>

<spe-import-footer
  *ngIf="currentStep === StepsImport.stepProcessing && showStepError && !showStepFail && errorsToShow.length > 0"
  [count]="quantidadeLinhasComErro"
  [label]="'Erros para corrigir'"
  [disabled]="quantidadeLinhasComErro > 0"
  (eventContinue)="continueFromError()"
>
</spe-import-footer>
